<template>
  <Modal
    :value="visible"
    :title="title"
    :width="1040"
    footer-hide
    @on-visible-change="onModalVisibleChange"
  >
    <Row
      type="flex"
      justify="start"
    >
      <i-col
        v-for="(dashboard, index) in modalDashboards"
        :key="index"
        span="8"
      >
        <Card
          class="dashboard-card"
          @click.native="openDashboard(dashboard)"
        >
          <p slot="title">
            {{ dashboard.title }}
          </p>
          <p>
            {{ dashboard.description }}
          </p>
          <div class="dashboard-tags">
            <Tag
              v-for="tag in getDashboardTags(dashboard)"
              :key="tag"
              :title="tag"
              class="dashboard-tag"
            >
              #{{ tag }}
            </Tag>
          </div>
        </Card>
      </i-col>
    </Row>
  </Modal>
</template>

<script>
export default {
  model: {
    prop: 'visible',
    event: 'change'
  },

  props: {
    visible: Boolean,
    dashboards: {
      type: Array,
      default: () => []
    },
    title: {
      type: String,
      default: 'Dashboards'
    }
  },

  computed: {
    modalDashboards () {
      // For now, we will only show the first 9 dashboards
      return this.dashboards.slice(0, 9)
    }
  },

  methods: {
    /**
     * Evoked when modal visibility changes
     * @param {Boolean} isVisible
     */
    onModalVisibleChange (isVisible) {
      this.$emit('change', isVisible)
    },

    /**
     * Opens the embedded dashboard in a new tab
     * @param {Object} dashboard
     */
    openDashboard (dashboard) {
      const url = `/dashboards/${dashboard.id}`

      window.open(url, '_blank')
    },

    /**
     * Based on dashboard object, returns an array of tag strings
     * @param {Object} dashboard
     * @return {Array}
     */
    getDashboardTags (dashboard) {
      const { categories = '' } = dashboard

      return categories.split(';')
    }
  }
}
</script>

<style scoped>
  .dashboard-card {
    margin: 8px;
    cursor: pointer;
    height: calc(100% - 8px);
  }

  .dashboard-tags {
    padding-top: 8px;
  }

  .dashboard-tag {
    max-width: unset;
    border-color: var(--color-card-border);
    background-color: transparent;
  }
</style>
